export const shellyConfig = {
  common: {
    saving: "Salvando...",
    online: "Online",
    offline: "Offline",
  },

  step1: {
    title: "Configuração do Shelly",
    subtitle:
      "Conecte sua conta Shelly Cloud para controlar seus relés (fechaduras elétricas, portões, etc.).",
    connected: "Conta conectada",
    notConnected: "Não conectada",
    credentialsInfo:
      "Encontre suas credenciais no app Shelly: <b>Configurações do usuário → Chave de autorização da nuvem</b>. Ali você verá a <b>Server URI</b> e poderá gerar sua <b>Auth Key</b>.",
    serverUriPlaceholder: "ex.: shelly-103-eu.shelly.cloud",
    serverUriHelp: "Servidor de nuvem atribuído à sua conta Shelly.",
    authKeyPlaceholderSaved: "•••••••• (já salva, opcional alterar)",
    authKeyPlaceholderNew: "Cole sua chave de autorização da nuvem",
    authKeyHelpSaved: "Você pode deixar em branco se já tiver uma chave salva.",
    authKeyHelpNew:
      "Esta chave permite controlar seus dispositivos: mantenha-a em segurança.",
    testing: "Testando...",
    testConnection: "Testar conexão",
    saveCredentials: "Salvar credenciais",
  },

  step2: {
    title: "Seletor de dispositivos para esta propriedade",
    subtitle:
      "Selecione apenas os relés Shelly que se aplicam a <b>esta propriedade</b>. Depois, no PMS você verá apenas os selecionados.",
    selectedCount: "{count} selecionado(s)",
    hintCredentials:
      "Insira sua Server URI e Auth Key e clique em <b>Testar conexão</b> para carregar seus dispositivos.",
    noDevices: "Nenhum dispositivo encontrado na sua conta Shelly.",
    selectPlaceholder: "Selecione dispositivos…",
    devicesSelected: "{count} dispositivo(s) selecionado(s)",
    noneSelected: "Nenhum dispositivo selecionado",
    channels: "{count} canais",
    saveDevices: "Salvar dispositivos para esta propriedade",
  },

  step3: {
    title: "Controle e atribuição (PMS)",
    subtitle:
      "Atribua cada relé a <b>Porta principal</b>, <b>Unidade</b> ou <b>Portão</b> e defina o pulso de abertura.",
    assignedCount: "{count} atribuído(s)",
    noSavedDevices:
      "Você ainda não tem dispositivos salvos para esta propriedade. Use o <b>Seletor</b> acima e depois salve.",
    pulseInfo:
      "<b>Abrir</b> envia um pulso ao relé (ele liga e desliga sozinho após os segundos configurados): ideal para fechaduras elétricas e portões. O Shelly não gera códigos PIN.",
    open: "Abrir",
    openTooltip: "Abrir (pulso)",
    turnOnTooltip: "Ligar relé",
    turnOffTooltip: "Desligar relé",
    refreshTooltip: "Atualizar status",
    assignment: "Atribuição",
    assignNone: "Não atribuído",
    assignCommon: "Porta principal (compartilhada)",
    assignUnit: "Porta do apartamento",
    assignGate: "Portão / Garagem",
    hintNone: "Não será controlado pelo PMS.",
    hintAssigned: "Será vinculado a esta propriedade para abertura remota.",
    unitLabel: "Unidade / Acomodação",
    selectUnit: "Selecione uma unidade",
    unitFallback: "Unidade {id}",
    selectUnitHint: "Escolha qual unidade este relé abre.",
    channelLabel: "Canal do relé",
    channelOption: "Canal {n}",
    channelHint: "Canal ligado à fechadura (dispositivos com múltiplos relés).",
    pulseLabel: "Pulso de abertura (segundos)",
    pulseHint: "Por quanto tempo o relé fica ligado ao abrir.",
    nameLabel: "Nome (opcional)",
    namePlaceholder: "ex.: Porta principal / Apto 101",
    nameHint: "Nome exibido no PMS para este dispositivo.",
    saveAssignment: "Salvar atribuição",
    tip:
      "Dica: Atribua cada relé e clique em <b>Salvar atribuição</b>. Os botões de controle são habilitados assim que o dispositivo é atribuído.",
  },

  toast: {
    loadDevicesFailed: "Não foi possível carregar os dispositivos",
    loadDevicesError: "Erro ao carregar dispositivos",
    missingCredentials: "Você precisa inserir a Server URI e sua Auth Key do Shelly.",
    connectionSuccess:
      "Conexão bem-sucedida. {count} dispositivo(s) encontrado(s).",
    testError: "Erro ao testar a conexão",
    invalidAuthKey: "Você precisa inserir uma Auth Key válida (pelo menos 10 caracteres).",
    missingServerUri: "Você precisa inserir a Server URI da sua conta Shelly.",
    credentialsSaved: "Credenciais salvas com sucesso",
    credentialsError: "Erro ao salvar credenciais",
    credentialsSaveError: "Erro ao salvar credenciais: {error}",
    selectAtLeastOne:
      "Você precisa selecionar pelo menos um dispositivo para esta propriedade.",
    devicesSaved: "Dispositivos salvos para esta propriedade",
    devicesSaveFailed: "Não foi possível salvar os dispositivos",
    saveError: "Erro ao salvar: {error}",
    selectUnitForApartment:
      "Selecione a unidade para os relés atribuídos como 'Porta do apartamento'.",
    assignmentFailed: "Não foi possível salvar a atribuição",
    assignmentSaved: "Atribuição salva com sucesso",
    assignmentSaveError: "Erro ao salvar a atribuição: {error}",
    opOpen: "Abertura enviada (pulso do relé)",
    opOn: "Relé ligado",
    opOff: "Relé desligado",
    opDone: "Ação concluída",
    opFailed: "Não foi possível concluir a ação",
    opError: "Erro ao executar a ação",
  },
};
